import type { CollabEditProvider } from '@atlaskit/editor-common/collab';
import type { CollabEditPluginOptions } from '@atlaskit/editor-plugin-collab-edit';

interface Props {
	options: CollabEditPluginOptions;
	providers: {
		collabEditProvider: Promise<CollabEditProvider> | undefined;
	};
}

export function collabEditPluginOptions({ options, providers }: Props): CollabEditPluginOptions {
	return {
		...options,
		provider: providers.collabEditProvider,
		sanitizePrivateContent: true,
		EXPERIMENTAL_allowInternalErrorAnalytics: options.EXPERIMENTAL_allowInternalErrorAnalytics,
	};
}
